import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-checkbox-config',
  templateUrl: './d-checkbox-config.component.html',
  styles: []
})
export class DCheckboxConfigComponent extends DynamicComponentBase {
  static KEY = 'd-checkbox-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}

  addRow() {
    const newRow = {
      value: '',
      label: ''
    };
    this.config.dataSource = [...this.config.dataSource, newRow];
  }
  deleteRow(i) {
    this.config.dataSource.splice(i, 1);
  }
}
